module.exports = __webpack_public_path__ + "img/how_to_join_2.7ecb6109.webp";